import { ChangeDetectionStrategy, Component, computed, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettingsStore } from '@app/core/state/app-settings-store/app-settings-store';
import { AuthStore } from '@app/core/state/auth.store';
import { TenantStateService } from '@app/core/services/tenant-state.service';
import { AuthService, UserService } from '@modules/auth/services';
import { ROUTE_ROOTS } from '@modules/navigation/models';

@Component({
    selector: 'sbpro-top-nav-user',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './top-nav-user.component.html',
    styleUrls: ['top-nav-user.component.scss'],
})
export class TopNavUserComponent implements OnInit {
    readonly accountProfileRoute = `/${ROUTE_ROOTS.PLATFORM}/account/profile`;
    @Input() placement = 'bottom-end';
    dropdownClasses: string[] = [];

    // Read user data from AuthStore which persists to localStorage
    private userInfoData = computed(() => this.authStore.userInfoData());

    user = computed(() => {
        const userInfo = this.userInfoData();
        if (!userInfo) return null;

        const firstName = userInfo.firstName || '';
        const lastName = userInfo.lastName || '';
        const name = [firstName, lastName].filter(Boolean).join(' ') || userInfo.email || '';

        return {
            name,
            email: userInfo.email || '',
            role: userInfo.roles?.[0] || '',
        };
    });

    // Use clientSlug from AuthStore, fallback to TenantStateService
    tenantSlug = computed(() =>
        this.userInfoData()?.clientSlug ||
        this.tenantStateService.tenantSlug() ||
        'N/A'
    );

    constructor(
        public userService: UserService,
        private appSettingsStore: AppSettingsStore,
        private authStore: AuthStore,
        private authService: AuthService,
        private router: Router,
        private tenantStateService: TenantStateService
    ) {}
    ngOnInit() {}

    logout(): void {
        this.authService.logout();
    }

}
